// extracted by mini-css-extract-plugin
export default {"ChartWrap":"util-admin-dashboard-chart_ChartWrap__X3BPe","ChartC":"util-admin-dashboard-chart_ChartC__PXsUB"};